let theme = {
  title: "Theme Set",
  subTitle:"Custom skin, theme",
  themeSet: {
    title: 'Theme',
    skin: {
      title: 'Skin',
      default: 'Default',
      border: 'Border',
      dark: 'Dark',
    },
    mode: {
      title: 'Model',
      highlight: 'Highlight',
      dark: 'Dark',

    }
  }
,
    layoutSet:{
      title:'Layout ',
      bodyWidth:{
        title:'Body width',
        beFilledWith:'Full',
        fine:'Compact'
      },
      appType:{
        title:'Application bar type',
        fixed:'Fixed',
        show:'Show',
        hide:'Hide'

      },
      nav:{
        title:'Navigation bar',
        merge:'Merge navigation bar',
        hide:'Hide navigation bar',
      }
    }



}

export default theme
